import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react'
import Helmet from 'react-helmet';

import { DefaultSheet, SheetBody, Tabs, TabsContent, TabsList, TabsTrigger } from 'twyne-new.ui';

import { useAppAlert } from '@Components/AppAlert';
import history from 'utils/history';

import DownloadUnsubscribe from '../components/Download';
import InProgress from '../components/InProgess';
import Form from '../components/UnsubscribeForm';
import { useIntegrationStore } from '../store';

const UnsubscribePropTypes = {
  match: PropTypes.object,
}

export default function Unsubscribe() {
  const { collections: { items }, getInProgress, unsubscribe, sendUnsubscribeEmail } = useIntegrationStore()
  const { handleSuccess, handleError } = useAppAlert()
  const [jobs, setJobs] = useState([])

  const loadData = useCallback(async () => {
    const jobs = await getInProgress()
    setJobs(jobs)
  }, [getInProgress])

  useEffect(() => {
    loadData()
  }, [loadData])

  const handleClose = useCallback(() => {
    history.push('/settings/integrations');
  }, [])

  const handleUnsubscribeSubmit = useCallback(async payload => {
    try {
      await unsubscribe(payload)
      handleSuccess('Success', `Unsubscribe saved.`)
      handleClose()
    } catch (error) {
      handleError('Error', 'Unsubscribe was not saved.')
    }
  }, [unsubscribe, handleClose, handleSuccess, handleError])

  const handleDownload = useCallback(async payload => {
    try {
      const response = await sendUnsubscribeEmail(payload)
      if (response !== true) {
        throw new Error('error')
      }
      handleSuccess('Success', `You request is being processed.`)
      handleClose()
    } catch (error) {
      handleError('Error', 'Failed to process your request.')
    }
  }, [sendUnsubscribeEmail, handleClose, handleSuccess, handleError])

  return <>
    <DefaultSheet title='Unsubscribe' wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleClose() }}>
      <Helmet title="Unsubscribe" />
      <Tabs defaultValue='unsubscribe'>
        <TabsList className='px-6'>
          <TabsTrigger value='unsubscribe'>Unsubscribe</TabsTrigger>
          <TabsTrigger value='inprogress'>In Progress</TabsTrigger>
          <TabsTrigger value='download'>Download</TabsTrigger>
        </TabsList>
        <TabsContent value='unsubscribe' className='mt-0!'>
          {items && items.length ? <Form data={items} handleSubmit={handleUnsubscribeSubmit} onCancel={handleClose} /> : null}
        </TabsContent>
        <TabsContent value='inprogress' className='mt-0!'>
          <SheetBody className='border-t-0 pt-4'>
            <InProgress jobs={jobs} />
          </SheetBody>
        </TabsContent>
        <TabsContent value='download' className='mt-0!'>
          <DownloadUnsubscribe onSubmit={handleDownload} />
        </TabsContent>
      </Tabs>
    </DefaultSheet>
  </>
}

Unsubscribe.propTypes = UnsubscribePropTypes
Unsubscribe.defaultProps = {}
